import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <section className="flex flex-col items-center justify-center py-20 text-center">
      <p className="text-sm font-semibold uppercase tracking-wider text-brand-600 dark:text-brand-400">
        404
      </p>
      <h1 className="mt-2 text-4xl font-bold tracking-tight text-slate-900 dark:text-slate-50">
        Page not found
      </h1>
      <p className="mt-2 max-w-md text-slate-600 dark:text-slate-300">
        We couldn&apos;t find the page you were looking for. It may have been
        moved or never existed.
      </p>

      <Link
        to="/client"
        className="mt-6 inline-flex h-10 items-center justify-center rounded-md bg-brand-600 px-4 text-sm font-medium text-white transition-colors hover:bg-brand-700"
      >
        Back to client home
      </Link>
    </section>
  );
}
